/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { LinkEditContext } from "cms/links/link-selector/context/edit";

const LinkEditHeader = () => {
    
    const {
        selectedLink
    } = useContext(LinkEditContext);
    
    let title = "Edit Internal Link";
    let { link_type } = selectedLink || {};
    if (link_type === "internal") {
        title = "Edit Internal Link";
    } else if (link_type === "external") {
        title = "Edit External Link";
    } else if (link_type === "mailto") {
        title = "Edit Mailto Link";
    } else if (link_type === "integration") {
        title = "Edit Integration Link";
    } else {
        title = "Edit Link";
    }

    return (
        <Fragment>
            <div className="simplicity-link-selector-window-title">
                {title}
            </div>
        </Fragment>
    );
};

export { LinkEditHeader };
